import { apiFetch, qk, useApiMutation, useApiQuery } from './client';
import type { EntradaAnimales, EntradaAnimalesInput } from '@/lib/types';

export function useEntradasAnimales(camadaId: number | null) {
  return useApiQuery<EntradaAnimales[]>({
    queryKey: qk('entradas-animales', 'camada', camadaId ?? 'none'),
    queryFn: () => apiFetch(`/v1/camadas/${camadaId}/entradas-animales`),
    enabled: camadaId != null,
    staleTime: 30_000,
  });
}

export function useGuardarEntrada(camadaId: number | null) {
  return useApiMutation<{ id?: number; data: EntradaAnimalesInput }, EntradaAnimales>({
    mutationFn: ({ id, data }, context) =>
      apiFetch(`/v1/camadas/${camadaId}/entradas-animales${id == null ? '' : `/${id}`}`, {
        method: id == null ? 'POST' : 'PATCH',
        body: JSON.stringify(data),
        offlineBase: context.offlineBase,
      }),
    invalidateKeys: [qk('entradas-animales'), qk('camadas'), qk('liquidacion-evolucion')],
  });
}
